
import { defineComponent } from "vue";
import { LanguageIcon } from "@/shared/ui";

export default defineComponent({
	name: "LanguageChanger",
	components: { LanguageIcon },
	data() {
		return {
			modal: false,
			languages: [
				{
					lang: "en",
					name: "English",
				},
				{
					lang: "ru",
					name: "Русский",
				},
				{
					lang: "be",
					name: "Беларуская",
				},
				{
					lang: "ua",
					name: "Українська",
				},
			],
		};
	},
	methods: {
		changeLanguage(language: { lang: string; name: string }) {
			this.$i18n.locale = language.lang;
			this.modal = false;
		},
	},
});
